import { useEffect } from "react";

import { Hero } from "@/components/hero/Hero";
import { EmotionalAnchor } from "@/components/landing/EmotionalAnchor";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { HowRevetraWorks } from "@/components/landing/HowRevetraWorks";
import { SpecialistTeam } from "@/components/landing/SpecialistTeam";
import { StatsStrip } from "@/components/landing/StatsStrip";
import { TrustHonesty } from "@/components/landing/TrustHonesty";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";

import "@/styles/landing.css";

// Reveal `.lp-reveal` elements as they scroll into view. Falls back to
// showing everything immediately when IntersectionObserver is absent or
// the user prefers reduced motion (handled in landing.css).
function useScrollReveal() {
  useEffect(() => {
    const targets = document.querySelectorAll<HTMLElement>(".lp-reveal");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export function Landing() {
  useScrollReveal();

  return (
    <div className="flex min-h-screen flex-col bg-parchment text-ink">
      <Header sticky />
      <main className="flex-1">
        <Hero />
        <StatsStrip />
        <HowRevetraWorks />
        <EmotionalAnchor />
        <SpecialistTeam />
        <TrustHonesty />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
